import React, { useState,useEffect } from 'react'
import "./tnp.css";
import { getDocs, collection,deleteDoc,doc } from "firebase/firestore";
import { db, auth } from "../../firebase";
import Tnpnav from "./Tnpnav";

export default function Showstu(prop) {
  const [joblist, setJoblist] = useState([]);

  const ref = collection(db, "users");
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);

  return (
    <>

{joblist.map((post) => {
  if(post.uid == prop.stuid){
        return (
           <>
            
              <td>{post.name}</td>
            <td>{post.email}</td>
            <td>{post.misid}</td>
            <td>{post.classes}</td>
            <td>{post.department}</td>
            <td>{post.roll}</td>
            {/* <td> <button className="btn-danger btn" onClick={()=>del(post.uid)}>Delete</button></td> */}
            
            
           
            </>
        );}
      })}
    </>
    
  )
}
